var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef, vModelText as _vModelText, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-1562a88e"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { style: { "display": "block" } };
var _hoisted_2 = { class: "flex items-center text-lg" };
var _hoisted_3 = { class: "modalscroll" };
var _hoisted_4 = { style: { "font-size": "15px" } };
var _hoisted_5 = { style: { "margin-right": "10px", "margin-left": "2%" } };
var _hoisted_6 = ["checked"];
var _hoisted_7 = { style: { "margin-right": "10px" } };
var _hoisted_8 = ["checked"];
var _hoisted_9 = { style: { "margin-right": "10px" } };
var _hoisted_10 = ["checked"];
var _hoisted_11 = ["checked"];
var _hoisted_12 = { class: "text-red-500 mb-2 w-full" };
var _hoisted_13 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1); });
var _hoisted_14 = { style: { "position": "relative", "display": "flex", "align-items": "center", "margin-left": "2%" } };
var _hoisted_15 = { class: "w-full mr-4" };
var _hoisted_16 = {
    for: "name",
    class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_17 = {
    role: "status",
    style: { "display": "inline-block", "margin-left": "2%" }
};
var _hoisted_18 = ["aria-hidden"];
var _hoisted_19 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("path", {
    d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
    fill: "currentColor"
}, null, -1); });
var _hoisted_20 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("path", {
    d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
    fill: "currentFill"
}, null, -1); });
var _hoisted_21 = [
    _hoisted_19,
    _hoisted_20
];
var _hoisted_22 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { class: "sr-only" }, "Loading...", -1); });
var _hoisted_23 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" }, [
    /*#__PURE__*/ _createElementVNode("svg", {
        "aria-hidden": "true",
        class: "w-5 h-5 text-gray-500 dark:text-gray-400",
        fill: "currentColor",
        viewBox: "0 0 512 512",
        xmlns: "http://www.w3.org/2000/svg",
        id: "search"
    }, [
        /*#__PURE__*/ _createElementVNode("path", { d: "M448.3 424.7L335 311.3c20.8-26 33.3-59.1 33.3-95.1 0-84.1-68.1-152.2-152-152.2-84 0-152 68.2-152 152.2s68.1 152.2 152 152.2c36.2 0 69.4-12.7 95.5-33.8L425 448l23.3-23.3zM120.1 312.6c-25.7-25.7-39.8-59.9-39.8-96.3s14.2-70.6 39.8-96.3 59.9-40 96.2-40c36.3 0 70.5 14.2 96.2 39.9s39.8 59.9 39.8 96.3-14.2 70.6-39.8 96.3c-25.7 25.7-59.9 39.9-96.2 39.9-36.3.1-70.5-14.1-96.2-39.8z" })
    ])
], -1); });
var _hoisted_24 = ["placeholder"];
var _hoisted_25 = ["selected", "value"];
var _hoisted_26 = { class: "text-red-500 mb-2 w-full" };
var _hoisted_27 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1); });
var _hoisted_28 = {
    style: { "margin-top": "2%", "margin-left": "2%" },
    class: "w-full"
};
var _hoisted_29 = {
    key: 0,
    for: "confidenzialità"
};
var _hoisted_30 = ["value"];
var _hoisted_31 = { style: { "display": "inline-block", "width": "45%", "margin-right": "2%", "margin-left": "2%" } };
var _hoisted_32 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", null, /*#__PURE__*/ _toDisplayString("Centro Indagine"), -1); });
var _hoisted_33 = {
    value: "",
    selected: "",
    disabled: "",
    hidden: ""
};
var _hoisted_34 = ["value"];
var _hoisted_35 = ["value"];
var _hoisted_36 = ["value"];
var _hoisted_37 = { style: { "display": "inline-block", "width": "45%" } };
var _hoisted_38 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", null, /*#__PURE__*/ _toDisplayString("Altro Centro"), -1); });
var _hoisted_39 = { style: { "display": "inline-block", "width": "45%", "margin-right": "2%", "margin-left": "2%" } };
var _hoisted_40 = {
    value: "",
    selected: "",
    disabled: "",
    hidden: ""
};
var _hoisted_41 = ["value"];
var _hoisted_42 = { class: "text-red-500 mb-2 w-full" };
var _hoisted_43 = {
    style: { "margin-top": "2%" },
    class: "w-full"
};
var _hoisted_44 = {
    for: "confidenzialità",
    class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_45 = ["value"];
var _hoisted_46 = { class: "diagnosi" };
var _hoisted_47 = { style: { "display": "inline-block", "margin-left": "1.5%", "margin-right": "1.5%", "width": "46%", "vertical-align": "top" } };
var _hoisted_48 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { style: { "margin-bottom": "2%" } }, [
    /*#__PURE__*/ _createElementVNode("strong", null, /*#__PURE__*/ _toDisplayString("Diagnosi Sospette"))
], -1); });
var _hoisted_49 = ["value"];
var _hoisted_50 = ["onChange", "checked"];
var _hoisted_51 = { style: { "display": "inline-block", "max-width": "85%", "vertical-align": "top" } };
var _hoisted_52 = { style: { "display": "inline-block", "width": "46%", "vertical-align": "top" } };
var _hoisted_53 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { style: { "margin-bottom": "2%" } }, [
    /*#__PURE__*/ _createElementVNode("strong", null, /*#__PURE__*/ _toDisplayString("Diagnosi Confermate"))
], -1); });
var _hoisted_54 = ["value"];
var _hoisted_55 = ["onChange", "checked"];
var _hoisted_56 = { style: { "display": "inline-block", "max-width": "85%", "vertical-align": "top" } };
var _hoisted_57 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1); });
var _hoisted_58 = { class: "flex justify-between" };
import { onMounted, reactive, onBeforeUnmount } from "vue";
import { ref } from "vue";
import { initFlowbite } from "flowbite";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import AlertModal from "@/components/AlertModalFeedback.vue";
import { Modal } from "flowbite-vue";
import { useRouter } from "vue-router";
import { filterEsamiByName } from "../../../../EshJSLib/services/esamiServices";
export default /*#__PURE__*/ _defineComponent({
    __name: 'esamiAggiuntiveEdit',
    emits: ["cancel"],
    setup: function (__props, _a) {
        var __expose = _a.expose, emit = _a.emit;
        var alertModal = ref(null);
        var store = patientStore();
        var patient = storeToRefs(store).patient;
        var esaminew = ref({});
        var alertConfirmMessage = ref(null);
        var showConfirm = ref(false);
        var resolvePromise;
        var isOpen = ref(false);
        //const mandatoryFields = ['indagine_tipologia', 'indagine_stato', 'id_livello_confidenzialita', 'careprovider','diags'];
        var mandatoryFields = ['indagine_tipologia', 'id_livello_confidenzialita'];
        var errors = ref([]);
        var errorMessage = "Questo campo è obbligatorio!";
        var esamiSrc = ref(false);
        var selectedEsami = {};
        var selectedEsamiReact = reactive(selectedEsami);
        var filteredEsami = {}; // diagnostic investigations
        var esamiSearch = "";
        var filteredEsamiReact = reactive(filteredEsami);
        var selectWrapper = ref(null);
        function handleClickOutside(event) {
            if (selectWrapper.value && !selectWrapper.value.contains(event.target)) {
                isOpen.value = false;
            }
        }
        function filtername() {
            esamiSrc.value = true;
            filteredEsami = {};
            if (esamiSearch.length > 2) {
                var res = filterEsamiByName(esamiSearch);
                res.then(function (value) {
                    filteredEsamiReact.DiagnosticInvestigation = value;
                    isOpen.value = true;
                    esamiSrc.value = false;
                });
            }
            else {
                // Stop spinner e chiudi la select se input troppo breve
                esamiSrc.value = false;
                isOpen.value = false;
            }
        }
        function onIndagineChange(e) {
            isOpen.value = false;
            if (!e.target)
                return;
            var id = e.target.value;
            var name = e.target.options[e.target.options.selectedIndex].text;
            esaminew.value.id_diagn_investigations = id;
            esamiSearch = name;
        }
        function clearIndagineSelection() {
            esaminew.value.id_diagn_investigations = 0;
            esamiSearch = '';
            isOpen.value = false;
        }
        onMounted(function () {
            errors.value = [];
            initFlowbite();
            document.addEventListener("click", handleClickOutside);
        });
        onBeforeUnmount(function () {
            document.removeEventListener("click", handleClickOutside);
        });
        var router = useRouter();
        function OpenDiagnosis() {
            router.push("/Registro/Diagnosi");
        }
        var open;
        function OpenCareprovider() {
            router.push("/Registro/Dottori");
        }
        function openModal(message, rowData) {
            errors.value = [];
            esaminew.value = rowData;
            esaminew.value.diags = esaminew.value.diags == null ? [] : esaminew.value.diags;
            esaminew.value.id_indagine = esaminew.value.id_indagine == null ? 0 : esaminew.value.id_indagine;
            esaminew.value.id_livello_confidenzialita = esaminew.value.id_livello_confidenzialita == null ? 4 : esaminew.value.id_livello_confidenzialita;
            alertConfirmMessage.value = message;
            showConfirm.value = true;
            return new Promise(function (resolve) {
                resolvePromise = resolve;
            });
        }
        function saveEsami() {
            if (!validateFields()) {
                return;
            }
            var date = new Date();
            alertModal.value.openModal("Sei sicuro di salvare i dati?", true).then(function (userInput) {
                if (userInput) {
                    showConfirm.value = false;
                    if (!resolvePromise)
                        return;
                    resolvePromise(true);
                }
            });
        }
        function validateFields() {
            var hasError = false;
            errors.value = [];
            mandatoryFields.forEach(function (field, index) {
                if (!esaminew.value[field]) {
                    console.log(field);
                    console.log(errors);
                    hasError = true;
                    errors.value.push(errorMessage);
                }
                else {
                    errors.value.push("");
                }
            });
            if (hasError) {
                return false;
            }
            return true;
        }
        function applyVal($event, index) {
            esaminew.value[index] = $event.target.value;
        }
        function assignVal(value) {
            esaminew.value.indagine_tipologia = value;
        }
        function assingCpp($event, id) {
            if ($event.target.checked) {
                esaminew.value.diags =
                    esaminew.value.diags.concat(id);
            }
            else {
                esaminew.value.diags = esaminew.value.diags.filter(function (d) { return d != id; });
            }
        }
        function closeModal() {
            store.fetchEsami();
            showConfirm.value = false;
            // if (!resolvePromise) return;
            // resolvePromise(false);
            emit("cancel");
        }
        __expose({ openModal: openModal });
        return function (_ctx, _cache) {
            var _component_Input = _resolveComponent("Input");
            return (showConfirm.value)
                ? (_openBlock(), _createBlock(_unref(Modal), {
                    key: 0,
                    size: "3xl",
                    onClose: closeModal
                }, {
                    header: _withCtx(function () { return [
                        _createVNode(AlertModal, {
                            ref_key: "alertModal",
                            ref: alertModal
                        }, null, 512),
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(alertConfirmMessage.value)), 1)
                        ])
                    ]; }),
                    body: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", null, [
                                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("Tipo dell'indagine *")), 1),
                                _createElementVNode("div", null, [
                                    _createElementVNode("label", _hoisted_5, [
                                        _createElementVNode("input", {
                                            id: "special",
                                            type: "radio",
                                            onChange: _cache[0] || (_cache[0] = function ($event) { return (assignVal('Studi Specialistici')); }),
                                            checked: _unref(esaminew).indagine_tipologia == 'Studi Specialistici'
                                        }, null, 40, _hoisted_6),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t("Studi Specialistici")), 1)
                                    ]),
                                    _createElementVNode("label", _hoisted_7, [
                                        _createElementVNode("input", {
                                            id: "radio",
                                            type: "radio",
                                            onChange: _cache[1] || (_cache[1] = function ($event) { return (assignVal('Studi Radiologici')); }),
                                            checked: _unref(esaminew).indagine_tipologia == 'Studi Radiologici'
                                        }, null, 40, _hoisted_8),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t("Studi Radiologici")), 1)
                                    ]),
                                    _createElementVNode("label", _hoisted_9, [
                                        _createElementVNode("input", {
                                            id: "analisi",
                                            type: "radio",
                                            onChange: _cache[2] || (_cache[2] = function ($event) { return (assignVal('Laboratori Analisi')); }),
                                            checked: _unref(esaminew).indagine_tipologia == 'Laboratori Analisi'
                                        }, null, 40, _hoisted_10),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t("Laboratori Analisi")), 1)
                                    ]),
                                    _createElementVNode("label", null, [
                                        _createElementVNode("input", {
                                            id: "patologia",
                                            type: "radio",
                                            onChange: _cache[3] || (_cache[3] = function ($event) { return (assignVal('Patologia')); }),
                                            checked: _unref(esaminew).indagine_tipologia == 'Patologia'
                                        }, null, 40, _hoisted_11),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t("Patologia")), 1)
                                    ])
                                ]),
                                _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(errors)[0]), 1)
                            ]),
                            _hoisted_13,
                            _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("Indagine")), 1),
                                    _withDirectives(_createElementVNode("div", _hoisted_17, [
                                        (_openBlock(), _createElementBlock("svg", {
                                            "aria-hidden": !_unref(esamiSrc),
                                            class: "w-5 h-5 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600",
                                            viewBox: "0 0 100 101",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg"
                                        }, _hoisted_21, 8, _hoisted_18)),
                                        _hoisted_22
                                    ], 512), [
                                        [_vShow, _unref(esamiSrc)]
                                    ]),
                                    _createElementVNode("div", {
                                        ref_key: "selectWrapper",
                                        ref: selectWrapper,
                                        class: "relative"
                                    }, [
                                        _hoisted_23,
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            id: "esame",
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return (_isRef(esamiSearch) ? (esamiSearch).value = $event : esamiSearch = $event); }),
                                            onKeyup: filtername,
                                            onClick: _cache[5] || (_cache[5] = function ($event) { return (_isRef(isOpen) //@ts-ignore
                                                ? isOpen.value = true : isOpen = true); }),
                                            class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                            placeholder: _ctx.$t('-- Inserisci indagine richiesta --')
                                        }, null, 40, _hoisted_24), [
                                            [_vModelText, _unref(esamiSearch)]
                                        ]),
                                        (_unref(esamiSearch))
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 0,
                                                class: "absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-500",
                                                onClick: clearIndagineSelection
                                            }, " ✖ "))
                                            : _createCommentVNode("", true)
                                    ], 512),
                                    _withDirectives(_createElementVNode("select", {
                                        ref_key: "selectWrapper",
                                        ref: selectWrapper,
                                        id: "esameSelect",
                                        class: _normalizeClass([{ 'border-red-500': _unref(errors)[0] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"]),
                                        onChange: _cache[6] || (_cache[6] = function ($event) { return (onIndagineChange($event)); }),
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) { return ((_unref(esaminew).id_diagn_investigations) = $event); }),
                                        size: "10"
                                    }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredEsamiReact.DiagnosticInvestigation, function (item) {
                                            return (_openBlock(), _createElementBlock("option", {
                                                selected: item.id === __spreadArray([], filteredEsamiReact.DiagnosticInvestigation, true)[0].id,
                                                key: item.id,
                                                value: item.id
                                            }, _toDisplayString(item.descrizione), 9, _hoisted_25));
                                        }), 128))
                                    ], 34), [
                                        [_vShow, _unref(isOpen) === true],
                                        [_vModelSelect, _unref(esaminew).id_diagn_investigations]
                                    ]),
                                    _createElementVNode("p", _hoisted_26, _toDisplayString(_unref(errors)[0]), 1)
                                ])
                            ]),
                            _hoisted_27,
                            _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_28, [
                                    (_unref(esaminew).id_indagine == 4)
                                        ? (_openBlock(), _createElementBlock("label", _hoisted_29, _toDisplayString(_ctx.$t("Livello di confidenzialità")) + ": * ", 1))
                                        : _createCommentVNode("", true),
                                    (_unref(esaminew).id_indagine == null)
                                        ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                            key: 1,
                                            id: "confidenzialità",
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) { return ((_unref(esaminew).id_livello_confidenzialita) = $event); }),
                                            class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                        }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).liveli_confidencialita, function (item, key) {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    value: item.id_livello_confidenzialita,
                                                    key: key
                                                }, _toDisplayString(item.confidenzialita_descrizione), 9, _hoisted_30));
                                            }), 128))
                                        ], 512)), [
                                            [_vModelSelect, _unref(esaminew).id_livello_confidenzialita]
                                        ])
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_31, [
                                    _hoisted_32,
                                    _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) { return ((_unref(esaminew).id_centro_indagine) = $event); }),
                                        id: "brand",
                                        name: "brand",
                                        class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500",
                                        style: { "width": "100%" }
                                    }, [
                                        _createElementVNode("option", _hoisted_33, _toDisplayString(_ctx.$t("Selezionare un Centro..")), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).centri_convenzionati_laboratory_analisi, function (item, key) {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: key,
                                                value: item.record_id
                                            }, _toDisplayString(item.centro_nome), 9, _hoisted_34));
                                        }), 128)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).centri_convenzionati_radiologici, function (item, key) {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: key,
                                                value: item.record_id
                                            }, _toDisplayString(item.centro_nome), 9, _hoisted_35));
                                        }), 128)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).centri_convenzionati_specialistici, function (item, key) {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: key,
                                                value: item.record_id
                                            }, _toDisplayString(item.centro_nome), 9, _hoisted_36));
                                        }), 128))
                                    ], 512), [
                                        [_vModelSelect, _unref(esaminew).id_centro_indagine]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_37, [
                                    _hoisted_38,
                                    _createVNode(_component_Input, {
                                        onChange: _cache[10] || (_cache[10] = function ($event) { return (applyVal($event, 'altro_centro')); }),
                                        id: "altro_centro",
                                        name: "altro_centro",
                                        placeholder: _unref(esaminew).altro_centro,
                                        class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500",
                                        style: { "width": "100%" }
                                    }, null, 8, ["placeholder"])
                                ])
                            ]),
                            _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_39, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("Professionista Sanitario")) + ":", 1),
                                    _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) { return ((_unref(esaminew).careprovider) = $event); }),
                                        class: _normalizeClass([{ 'border-red-500': _unref(errors)[2] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"]),
                                        id: "brand",
                                        name: "brand",
                                        style: { "width": "100%" }
                                    }, [
                                        _createElementVNode("option", _hoisted_40, _toDisplayString(_ctx.$t("Selezionare un Professionista Sanitario")) + "... ", 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).associated_doctors, function (item) {
                                            var _a, _b, _c;
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: (_a = item.care_provider) === null || _a === void 0 ? void 0 : _a.id_utente,
                                                value: (_b = item.care_provider) === null || _b === void 0 ? void 0 : _b.fullname
                                            }, _toDisplayString((_c = item.care_provider) === null || _c === void 0 ? void 0 : _c.fullname), 9, _hoisted_41));
                                        }), 128))
                                    ], 2), [
                                        [_vModelSelect, _unref(esaminew).careprovider]
                                    ]),
                                    _createElementVNode("p", _hoisted_42, _toDisplayString(_unref(errors)[2]), 1)
                                ]),
                                _createElementVNode("button", {
                                    onClick: OpenCareprovider,
                                    class: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                                }, " Nuovo Professionista Sanitario "),
                                (_unref(open) == true)
                                    ? (_openBlock(), _createBlock(_component_Input, {
                                        key: 0,
                                        modelValue: _unref(esaminew).careprovider,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) { return ((_unref(esaminew).careprovider) = $event); }),
                                        placeholder: 'inserisci nuovo careprovider',
                                        class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                    }, null, 8, ["modelValue"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_43, [
                                _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t("Livello di confidenzialità")) + ": * ", 1),
                                _withDirectives(_createElementVNode("select", {
                                    id: "confidenzialità",
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = function ($event) { return ((_unref(esaminew).id_livello_confidenzialita) = $event); }),
                                    class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).liveli_confidencialita, function (item, key) {
                                        return (_openBlock(), _createElementBlock("option", {
                                            value: item.id_livello_confidenzialita,
                                            key: key
                                        }, _toDisplayString(item.confidenzialita_descrizione), 9, _hoisted_45));
                                    }), 128))
                                ], 512), [
                                    [_vModelSelect, _unref(esaminew).id_livello_confidenzialita]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("div", _hoisted_47, [
                                    _hoisted_48,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).diagnosi.filter(function (dg) { return dg.diagnosi_stato == '1'; }), function (item, key) {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: key,
                                            value: item.id_diagnosi,
                                            style: { "width": "100%", "margin-bottom": "2%" }
                                        }, [
                                            _createElementVNode("input", {
                                                onChange: function ($event) { return (assingCpp($event, item.id_diagnosi)); },
                                                checked: _unref(esaminew).diags.includes(item.id_diagnosi),
                                                type: "checkbox",
                                                style: { "display": "inline-block", "margin-right": "3%", "max-width": "10%", "vertical-align": "top" }
                                            }, null, 40, _hoisted_50),
                                            _createElementVNode("p", _hoisted_51, _toDisplayString(item.diagnosi_patologia), 1)
                                        ], 8, _hoisted_49));
                                    }), 128))
                                ]),
                                _createElementVNode("div", _hoisted_52, [
                                    _hoisted_53,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).diagnosi.filter(function (dg) { return dg.diagnosi_stato == '0'; }), function (item, key) {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: key,
                                            value: item.id_diagnosi,
                                            style: { "width": "100%", "margin-bottom": "2%" }
                                        }, [
                                            _createElementVNode("input", {
                                                onChange: function ($event) { return (assingCpp($event, item.id_diagnosi)); },
                                                checked: _unref(esaminew).diags.includes(item.id_diagnosi),
                                                type: "checkbox",
                                                style: { "display": "inline-block", "margin-right": "3%", "max-width": "10%", "vertical-align": "top" }
                                            }, null, 40, _hoisted_55),
                                            _createElementVNode("p", _hoisted_56, _toDisplayString(item.diagnosi_patologia), 1)
                                        ], 8, _hoisted_54));
                                    }), 128))
                                ])
                            ]),
                            _createElementVNode("button", {
                                onClick: OpenDiagnosis,
                                class: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                            }, " Aggiungere nuova diagnosi"),
                            _hoisted_57
                        ])
                    ]; }),
                    footer: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_58, [
                            _createElementVNode("button", {
                                onClick: closeModal,
                                type: "button",
                                class: "text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                            }, _toDisplayString(_ctx.$t("Annulla")), 1),
                            _createElementVNode("button", {
                                onClick: _cache[14] || (_cache[14] = function ($event) { return (saveEsami()); }),
                                type: "button",
                                class: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                            }, _toDisplayString(_ctx.$t("Concludi Indagine")), 1)
                        ])
                    ]; }),
                    _: 1
                }))
                : _createCommentVNode("", true);
        };
    }
});
